import React from 'react'
import { Modal, Button, Accordion, Feed, Divider, Icon, List } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';

import { Form } from 'formsy-semantic-ui-react';

import 'react-quill/dist/quill.snow.css'; // ES6
import MomentTime from '../../../../common/MomentTime';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import TextEditor from '../../../../common/TextEditor';


// const _ = require('lodash');
var moment = require('moment');
class OnHoldModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activateComments: '',
            activeIndex: 0
        }

    }
    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }
    close = () => {
        this.setState({ activateComments: '' });
        this.props.OnHoldActivateModalClose(false);
    }

    addOnHoldActivateComments = () => {
        if (this.props.selectedActivityData.issueLogComments && this.props.selectedActivityData.issueLogComments.length
            && this.props.selectedActivityData.issueLogComments[0].issueStatus === 0) {
            this.props.selectedActivityData.issueFlag = true;
        }
        const today = new Date();
        const todayStr = `${today.getFullYear}-${today.getMonth + 1}-${today.getDate}`;
        const todaysStartTime = moment(`${todayStr} 00:00`, "YYYY-MM-DD hh:mm");
        const todayEndTime = moment(`${todayStr} 23:59`, "YYYY-MM-DD hh:mm");

        const activityStartDate = moment(this.props.selectedActivityData.expectedStartDate, "YYYY-MM-DD hh:mm");
        const activityEndDate = moment(this.props.selectedActivityData.endDate, "YYYY-MM-DD hh:mm");

        if (activityStartDate < todaysStartTime) {
            this.props.selectedActivityData.isDelayedToStart = true;
        }
        else if (activityEndDate < todayEndTime) {
            this.props.selectedActivityData.isDelayedToEnd = true;
        }

        this.props.selectedActivityData.onHoldFlag = false;
        this.props.selectedActivityData.string = "ActivatePutOnHold"
        this.props.selectedActivityData.onHoldComments[0].activateComment = this.state.activateComments;
        this.props.selectedActivityData.onHoldComments[0].actiavteOnHoldDate = moment();
        if (this.props.activeTab === "myactivities") {
            dispatch.initiatives.updateMemberActivities(this.props.selectedActivityData);
        }
        else {
            dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
        }
        this.close();


    }
    getMapping(id) {
        if (this.props.activityOptions) {
            for (let i = 0; i < this.props.activityOptions.length; i++) {
                let activity = this.props.activityOptions[i];
                if (id.toString() === activity._id.toString()) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id.toString() === subActivity._id.toString()) {
                            return activity.name + " > " + subActivity.name;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (id.toString() === childActivity._id.toString()) {
                                    return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    updateText = (data, name) => {
        if (name === "Comment") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ activateComments: '' })
            } else {
                this.setState({ activateComments: data })
            }
        }
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const { activeIndex } = this.state
        return (
            <Modal
                className="NotesModalCard basicModal"
                open={this.props.onHoldActivateFlag}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    <strong className="clr-blue">Activate</strong>
                </Modal.Header>
                <Modal.Content scrolling>
                    <span className="head">{this.props.selectedActivityData.name}</span>
                    {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.length ?

                        <Accordion className="onHoldModal">
                            <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                                <Icon name='dropdown' />
                                There are {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.length} dependent activities which will resume.
                             </Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                <List divider>
                                    {this.props.selectedActivityData.dependentNodes && this.props.selectedActivityData.dependentNodes.map((dependency) => {
                                        return (<List.Item key={dependency}>
                                            <List.Content className="list_content" verticalAlign='middle'>{this.getMapping(dependency)}</List.Content>
                                        </List.Item>)

                                    })}
                                </List>
                            </Accordion.Content>
                        </Accordion>

                        : ''}

                    <Feed className={`issueMessage ${this.props.resolvedModal} bg-light-blue `} >
                        <Feed.Event className="pad_10">
                            <ImageAvater user={this.props.selectedActivityData.onHoldComments[0].accountUserId} />
                            <Feed.Content>
                                <Feed.Summary>
                                    {this.props.selectedActivityData.onHoldComments[0].accountUserId.firstName} {this.props.selectedActivityData.onHoldComments[0].accountUserId.lastName} <span>has put this activity on hold</span>
                                    <span className="pull-right">
                                        <MomentTime date={this.props.selectedActivityData.onHoldComments[0].onHoldDate} />
                                    </span>
                                </Feed.Summary>
                                <Feed.Date> <span className="pull-right" style={{ textAlign: "right" }}>
                                    <MomentTime date={this.props.selectedActivityData.onHoldComments[0].onHoldDate} />

                                </span></Feed.Date>
                            </Feed.Content>
                        </Feed.Event>
                        <Divider className="mar_0" />
                        <div className="pad_10">
                            <div dangerouslySetInnerHTML={{ __html: this.props.selectedActivityData.onHoldComments[0].comment }} />
                        </div>
                    </Feed>


                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="issue"
                        id="issueid"
                        onValidSubmit={() => { this.addOnHoldActivateComments() }}
                    >
                        <TextEditor
                            name="Comment"
                            text={this.state.activateComments}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />
                        <br />
                        <div className="pull-right" style={{ "marginBottom": "25px" }}>
                            <Button content='Cancel' className="button-cancel" onClick={this.close} />
                            <Button type="submit" content='Resume' disabled={this.state.activateComments.length === 0} className="button-submit" />
                        </div>
                        <br />
                    </Form >
                </Modal.Content>

            </Modal>


        )
    }
}



export default OnHoldModal;